module.exports = __webpack_public_path__ + "static/media/gailKaren60.f800a2f4.png";